import React, { useState, useEffect } from "react";
import { useData } from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import currency from "../../../utils/currency";
import TabPanel from "../../../components/TabPanel";
import tableIcons from "../../../components/tableicon/table-icons";
import MaterialTable from "material-table";

function TopJaringan({ value }) {
  const { profil } = useData();
  const [table, setTable] = useState({
    columns: [
      { title: "Nama", field: "nama" },
      { title: "Periode", field: "bulan" },
      {
        title: "Sales Team",
        field: "total_sales",
        render: (rowData) => {
          return currency(rowData.total_sales);
        },
      },
    ],
    data: [],
  });

  const getData = async () => {
    if (profil?.tipe_akun === "agen") {
      return;
    }

    try {
      const func = firefunctions.httpsCallable("getTopJaringan");

      const res = await func({ user_id: profil.id });
      setTable((table) => {
        return {
          ...table,
          data: res?.data.map((doc) => {
            return {
                ...doc,
              nama: doc.nama,
              bulan: doc.bulan,
              total_sales: doc.total_sales,
            };
          }),
        };
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <TabPanel value={value} index="jaringan">
      <MaterialTable
        title="Daftar Jaringan"
        icons={tableIcons}
        columns={table.columns}
        data={table.data}
        components={{
          Container: (props) => <div {...props} elevation={0} />,
        }}
        localization={{
          body: {
            emptyDataSourceMessage: `Tidak Ada Data ${
              profil?.tipe_akun === "agen" ? " Bagi Agen" : ""
            }`,
          },
          toolbar: {
            searchTooltip: "Cari",
            searchPlaceholder: "Cari Data",
          },
          header: {
            actions: "Actions",
          },
          pagination: {
            labelRowsSelect: "Baris",
            labelDisplayedRows: " {from}-{to} Dari {count} Baris",
            firstTooltip: "Halaman Pertama",
            previousTooltip: "Halaman Sebelumnya",
            nextTooltip: "Halaman Selanjutnya",
            lastTooltip: "Halaman Terakhir",
          },
        }}
      />
    </TabPanel>
  );
}

export default TopJaringan;
